import Vue from "vue";
// TODO : revoir
// import Notification from "../../helpers/Notification";
import LogHelper from "../logHelper";
// import Authentication from "../../helpers/Authentication";

class ControllerBase {
  constructor() {
    this.EventBus = new Vue();
    // this.Notification = Notification;
    this.Log = new LogHelper();
    // this.Authentication = new Authentication();
  }
}

export default ControllerBase;
